import SubTitle from "./Subtitle";

export default function Title(props){
    return(
        <>
            <h2 className="text-4xl text-advise-color font-bold leading-tight information-title">
                {props.title}
            </h2>
            <SubTitle/>
            {props.subtitle ? 
                <div className="subheader-container">
                    <p className="text-gray-700 leading-tight information-subtitle" 
                    style={{fontSize: "1.35rem", maxWidth: "90%"}}>
                        {props.subtitle}
                    </p>
                </div>        
            :<></>}
        </>
    )
}